// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604210803/js/" + chunkId + "." + {"44":"714ae6be","225":"0dd58a32","481":"617e858d","486":"fd3b7281","770":"934d885a"}[chunkId] + ".0.7676186210311486.chunk.js";
};